module.exports = __webpack_public_path__ + "static/img/zengniyou_icon.c3cca2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/zengniyou_icon.png
// module id = UTpZ
// module chunks = 1